import React, { useState } from "react";

import FormGroup from "../FormGroup";

import style from "./style.module.css";

export default function Textarea(props) {
    const [focus, setFocus] = useState(false);
    const { input: { value, onBlur, onChange, name }, placeholder, maxLength, onKeyUpHandler, disabled, showcount, currentValue, label, meta, required } = props;

    const onBlurHandler = (e) => {
        onBlur(e);
        setTimeout(() => setFocus(false));
    }

    return (
        <FormGroup
            label={label}
            required={required}
            meta={meta}
            focus={focus}
            value={value}
            inputType="textArea"
            disabled={disabled}
            fieldName={name}
            fieldValue={value}
        >
            <div className={`${showcount ? style.hasCount : ""}`}>
                <textarea
                    value={value}
                    placeholder={placeholder}
                    maxLength={maxLength}
                    onFocus={() => setFocus(true)}
                    onKeyUp={onKeyUpHandler}
                    disabled={disabled}
                    onChange={onChange}
                    onBlur={onBlurHandler}
                    className={`${style.textArea}`}
                >
                </textarea>
                {
                    showcount === true && (
                        <div className={style.valueCount}>{currentValue.length || 0}/{maxLength} characters used</div>
                    )
                }
            </div>
        </FormGroup>
    )
}